export class Upload {
    public id: number;
    public reservation_id?: number;
    public page_id?: number;
    public setting_id?: number;
    public description?: string;
    public user_id: number;
    public name: string;
    public type: string;
    public url: string;
    public created: string;

    constructor(id: number, user_id: number, name: string,
                type: string, url: string, created: string,
                reservation_id?: number, page_id?: number, setting_id?: number, description?: string) {
        this.id = id;
        this.user_id = user_id;
        this.name = name;
        this.type = type;
        this.url = url;
        this.created = created;
        this.reservation_id = reservation_id;
        this.page_id = page_id;
        this.setting_id = setting_id;
        this.description = description;
    }

}

export class UploadCreate {

    public reservation_id?: number;
    public page_id?: number;
    public setting_id?: number;
    public description?: string;
    public user_id: number;
    public name: string;
    public type: string;
    public url: string;

    constructor(user_id: number, name: string, type: string, url: string,
                reservation_id?: number, page_id?: number, setting_id?: number, description?: string) {
        this.user_id = user_id;
        this.name = name;
        this.type = type;
        this.url = url;
        this.reservation_id = reservation_id;
        this.page_id = page_id;
        this.setting_id = setting_id;
        this.description = description;
    }

}
